import { VuiHelmet } from "../../../../@vendor/components";
import { useTranslation } from "react-i18next";
import GuestCheckoutBookingCounselingModule from "../../../../modules/guest-checkout-booking-counseling";

const GuestCheckoutBookingCounseling = () => {
  const { t } = useTranslation();

  return (
    <div id="app-cart-page">
      <VuiHelmet title={t("common.text.checkout")} />
      <GuestCheckoutBookingCounselingModule />;
    </div>
  );
};

export default GuestCheckoutBookingCounseling;
